import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Registramos los componentes necesarios de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartCustom = ({ items = [], title = "Gráfica de Totales", containerStyle = {} }) => {

    const colors = [
    'rgba(255, 99, 132, 0.6)', // Rojo
    'rgba(54, 162, 235, 0.6)', // Azul
    'rgba(255, 206, 86, 0.6)', // Amarillo
    'rgba(75, 192, 192, 0.6)', // Verde
    'rgba(153, 102, 255, 0.6)', // Morado
    'rgba(255, 159, 64, 0.6)',  // Naranja
  ];
  
  const MAX_LENGTH = 25;
  // Mapeamos los datos del arreglo items
  const data = {

    

    labels: items.map(item => 
      item.nombre.length > MAX_LENGTH 
        ? item.nombre.substring(0, MAX_LENGTH) + "..." 
        : item.nombre
    ),
    datasets: [
      {
        label: 'Total',
        data: items.map(item => item.total),
        backgroundColor: colors, // Color azul con transparencia
        borderColor: colors.map(c => c.replace('0.6', '1')),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Permite que el gráfico se adapte al tamaño del contenedor
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: !!title,
        text: title,
      },
    },
  };

  // El div contenedor controla el tamaño final del componente
  return (
    <div style={{ position: 'relative', width: '100%', height: '400px', ...containerStyle }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default BarChartCustom;